(() => {
  "use strict";

  const FORM_SEL = 'form[action*="/cart/add"]';
  const qAll = (r, s) => Array.from(r.querySelectorAll(s));
  const rootOf = n => n.closest('[id^="shopify-section"]') || n.closest('section') || document;
  const scopeOf = f => f.closest('product-form') || f;
  const esc = s => (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/["\\]/g,"\\$&");

  function groupKeys(root){
    const keys = new Set();
    qAll(root,'select[name^="options["],select[name^="option"]').forEach(el => el.name && keys.add(`n:${el.name}`));
    const radioNames = [...new Set(qAll(root,'input[type="radio"][name^="options["],input[type="radio"][name^="option"]').map(r => r.name))];
    radioNames.forEach(n => keys.add(`n:${n}`));
    qAll(root,'[data-option-position],[data-option-index],[data-product-option],[role="radiogroup"]').forEach(el => {
      const k = el.dataset.optionPosition || el.dataset.optionIndex || el.dataset.productOption || el.getAttribute('aria-label');
      if (k) keys.add(`d:${k}`);
    });
    return [...keys];
  }

  function hasAllValues(root){
    const selects = qAll(root,'select[name^="options["],select[name^="option"]');
    const radios  = [...new Set(qAll(root,'input[type="radio"][name^="options["],input[type="radio"][name^="option"]').map(r => r.name))];
    const sOk = selects.every(sel => sel.value !== "" && sel.value != null);
    const rOk = radios.every(n => qAll(root, `input[type="radio"][name="${esc(n)}"]`).some(r => r.checked));
    return (selects.length + radios.length) ? (sOk && rOk) : true;
  }

  /* ---------- Spin-Assemble Popup ---------- */
  function buildHint(state){
    if (state.hint) return state.hint.el;
    const el = document.createElement('div');
    el.className = 'atc-hint';
    el.setAttribute('role','alert'); el.setAttribute('aria-live','polite');

    const card = document.createElement('div'); card.className = 'atc-hint__card';

    const title = document.createElement('div'); title.className = 'atc-hint__title';
    title.textContent = 'Noch ein Schritt';

    const letters = document.createElement('div'); letters.className = 'atc-hint__letters';
    letters.setAttribute('aria-label','Bitte zuerst Farbe & Größe wählen');
    // Buchstaben vorbereiten (zwei Hälften kommen von links/rechts)
    const text = 'Bitte zuerst Farbe & Größe wählen';
    let left = true, idx = 0;
    for (const ch of text){
      if (ch === ' '){
        const sp = document.createElement('span'); sp.className = 'space'; sp.textContent = ' ';
        letters.appendChild(sp); continue;
      }
      const span = document.createElement('span');
      span.className = 'char';
      // alternierende Herkunft
      span.style.setProperty('--from', left ? '-14px' : '14px');
      span.style.setProperty('--rot',  left ? '-6deg' : '6deg');
      span.style.setProperty('--delay', (100 + idx*24) + 'ms');
      span.textContent = ch;
      letters.appendChild(span);
      left = !left; idx++;
    }

    card.appendChild(title);
    card.appendChild(letters);
    el.appendChild(card);
    document.body.appendChild(el);

    state.hint = { el, letters, hideTimer:null, onPos:null };
    return el;
  }

  function animateLetters(state){
    const chars = state.hint.letters.querySelectorAll('.char');
    chars.forEach(ch => ch.classList.add('char--in'));
  }

  function showHint(target, state){
    const el = buildHint(state);

    const place = () => {
      const rect = target.getBoundingClientRect();
      const x = rect.left + rect.width/2;
      const y = Math.max(12, rect.top - 14);
      el.style.left = `${x}px`; el.style.top = `${y}px`;
    };
    place();
    el.classList.add('atc-hint--show');

    // Start der Buchstaben-Animation im nächsten Frame
    requestAnimationFrame(() => animateLetters(state));

    if (state.hint.onPos){ window.removeEventListener('scroll', state.hint.onPos, true); window.removeEventListener('resize', state.hint.onPos, true); }
    state.hint.onPos = () => place();
    window.addEventListener('scroll', state.hint.onPos, true);
    window.addEventListener('resize', state.hint.onPos, true);

    clearTimeout(state.hint.hideTimer);
    state.hint.hideTimer = setTimeout(() => hideHint(state), 2200);
  }

  function hideHint(state){
    if (!state.hint) return;
    state.hint.el.classList.remove('atc-hint--show');
    // Reset für nächsten Aufruf
    state.hint.letters.querySelectorAll('.char').forEach(ch => ch.classList.remove('char--in'));
    clearTimeout(state.hint.hideTimer);
    window.removeEventListener('scroll', state.hint.onPos, true);
    window.removeEventListener('resize', state.hint.onPos, true);
  }
  /* ---------------------------------------- */

  function lock(state){ state.scope.classList.add('atc-locked'); }
  function unlock(state){ state.scope.classList.remove('atc-locked'); hideHint(state); }

  function evaluate(state){
    const { form, root, groups, touched } = state;
    const touchedOk = groups.every(k => touched.get(k) === true);
    const valuesOk  = hasAllValues(root);
    const vOk       = !!form.querySelector('input[name="id"]')?.value;
    if (vOk && valuesOk && touchedOk) unlock(state); else lock(state);
  }

  function markTouched(e, state){
    const t = e.target; if (!t) return;
    const sel = t.closest && t.closest('select[name^="options["],select[name^="option"]');
    if (sel && sel.name) state.touched.set(`n:${sel.name}`, true);
    const rad = t.closest && t.closest('input[type="radio"][name^="options["],input[type="radio"][name^="option"]');
    if (rad && rad.name) state.touched.set(`n:${rad.name}`, true);
    const holder = t.closest && t.closest('[data-option-position],[data-option-index],[data-product-option],[role="radiogroup"]');
    if (holder){
      const k = holder.dataset.optionPosition || holder.dataset.optionIndex || holder.dataset.productOption || holder.getAttribute('aria-label') || 'swatch';
      state.touched.set(`d:${k}`, true);
    }
  }

  function bind(form){
    if (form.__lockBound) return;
    form.__lockBound = true;

    const root  = rootOf(form);
    const scope = scopeOf(form);
    const groups = groupKeys(root);
    const touched = new Map(groups.map(k => [k, false]));
    const state = form.__lockState = { form, root, scope, groups, touched, hint:null };

    lock(state);
    evaluate(state);

    // Klicks auf gesperrte Buttons → Popup zeigen
    root.addEventListener('click', (e) => {
      if (!scope.classList.contains('atc-locked')) return;
      const tgt = e.target.closest('button[name="add"], button[type="submit"], .product-form__submit, .shopify-payment-button, .dynamic-checkout');
      if (!tgt) return;
      showHint(tgt, state);
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }, true);

    // Auswahltracking
    const onInteract = (e) => { markTouched(e, state); evaluate(state); };
    root.addEventListener('pointerdown', onInteract, true);
    root.addEventListener('click',       onInteract, true);
    root.addEventListener('keydown',     onInteract, true);

    // Theme/Variant Events
    ['variant:change','theme:variant:change','product:variant-change','theme:section:variant']
      .forEach(ev => root.addEventListener(ev, () => evaluate(state)));

    const vId = form.querySelector('input[name="id"]');
    if (vId) new MutationObserver(() => evaluate(state)).observe(vId, { attributes:true, attributeFilter:['value'] });

    // DOM-Rebuild
    new MutationObserver(() => {
      const newKeys = groupKeys(root);
      if (newKeys.length !== state.groups.length || newKeys.some(k => !state.touched.has(k))){
        newKeys.forEach(k => { if (!state.touched.has(k)) state.touched.set(k, false); });
        state.groups = newKeys; evaluate(state);
      }
    }).observe(root, { childList:true, subtree:true });

    // Späte Inits
    let n = 30; const timer = setInterval(() => { evaluate(state); if (--n <= 0) clearInterval(timer); }, 300);
  }

  function init(ctx=document){ qAll(ctx, FORM_SEL).filter(f => f.offsetParent !== null).forEach(bind); }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
    